import {
    DraftSaveCalendarViewConfig,
    SaveCalendarViewConfig,
} from '../store/schema/SaveCalendarViewConfig';
import { getGuid } from 'owa-guid';

/**
 * Creates a SaveCalendarViewConfig from an DraftSaveCalendarViewConfig.
 * Creates a unique ID for this object.
 */
export function createSaveCalendarViewConfig(
    draftSaveCalendarViewConfig: DraftSaveCalendarViewConfig
): SaveCalendarViewConfig {
    let newSaveCalendarViewConfig: SaveCalendarViewConfig = {
        id: getGuid(),
        ...draftSaveCalendarViewConfig,
    };
    return newSaveCalendarViewConfig;
}
